export default {
  home: 'Home',
  separator: '>'
};